import { render, staticRenderFns } from "./news2List.vue?vue&type=template&id=29cc01ea&scoped=true&"
import script from "./news2List.vue?vue&type=script&lang=js&"
export * from "./news2List.vue?vue&type=script&lang=js&"
import style0 from "./news2List.vue?vue&type=style&index=0&id=29cc01ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29cc01ea",
  null
  
)

export default component.exports